export const getStatus = (ad) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const lastDayToRespond = new Date(ad.last_day_to_respond);

  if (ad.status === 'draft') {
    return 'draft';
  }

  if (ad.status === 'withdrawn' || lastDayToRespond < today) {
    return 'ended';
  }

  if (ad.status === 'active' && lastDayToRespond >= today) {
    return 'active';
  }

  return 'ended';
};
